import { render } from "./PremiumTrophy.vue?vue&type=template&id=5f0cfbc3"
import script from "./PremiumTrophy.vue?vue&type=script&lang=js"
export * from "./PremiumTrophy.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__